import { render, staticRenderFns } from "./create-order-transfer-promo.vue?vue&type=template&id=d933d738&"
import script from "./create-order-transfer-promo.vue?vue&type=script&lang=js&"
export * from "./create-order-transfer-promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports